// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ew: 0px;
}
.main {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.titleSection {
  display: flex;
  margin-top: 1rem;
  align-items: center;
  position: relative;
}

.titleSection img {
  width: 32px;
  height: 32px;
}

.title {
  color: #000000;
  font-size: 32px;
  font-weight: 700;
  margin-right: 19px;
}

.secondTitle {
  color: #aeaaae !important;
  font-size: 32px !important;
  font-weight: 700 !important;
  position: absolute;
  left: 119px !important;
  z-index: 100;
}

.subtitle {
  color: #1c1b1f;
  font-size: 22px;
  font-weight: 700;
}

.producerInfoSubtitle {
  color: #939094;
  font-size: 13px;
  font-weight: 400;
}

.producerInfoBusinessName {
  color: #939094;
  font-size: 13px;
  font-weight: 700;
}

.divider::after {
  content: '';
  display: block;
  width: 100%;
  height: 1px;
  background-color: #ebebeb;
}

.countProducers {
  display: flex;
  flex-direction: column;
  margin-top: 3rem;
  padding-top: 1.25rem;
  min-height: 54.39px;
  background-color: #ffffff;
}

.producersContainer {
  margin-bottom: 100px;
}

.producersContainer .listActions {
  background: white;
  position: sticky;
  top: 50px;
  display: grid;
  grid-template-columns: calc(100% - 72px) 56px;
  column-gap: 1rem;
  row-gap: 0.5rem;
}

/* new styles */
.producersContainer .inputsContainer {
  background: white;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 56px;
  grid-template-rows: auto auto;
  gap: 1rem;
  padding-bottom: 10px;
}

.subtitleStatic {
  padding-bottom: 0;
  padding-top: 0;
  position: static;
}

.subtitleFixed {
  position: fixed !important;
  top: 0 !important;
  background: #ffffff !important;
  transition: all 0.3s ease-in-out 0.2s !important;
  width: 100% !important;
  padding-top: 1.25rem !important;
}

.subtitleFixedHide {
  position: fixed !important;
  transition: all 0.3s ease-in-out 0.2s !important;
  top: -100px !important;
  margin-bottom: 0 !important;
  padding-bottom: 0.5rem !important;
}

.inputsContainerFixed {
  position: fixed !important;
  transition: all 0.3s ease-in-out 0.2s !important;
  top: 46.39px !important;
  width: var(--ew) !important;
  background: #ffffff !important;
}

.inputsContainerFixedHide {
  position: fixed !important;
  transition: all 0.3s ease-in-out 0.2s !important;
  top: -170px !important;
  width: var(--ew) !important;
  background: #ffffff !important;
}

.min-h-162 {
  min-height: 162px;
}

.producersContainer .inputsContainer .first {
  grid-column: 1 / 3;
}

.producersContainer .inputsContainer .second {
  grid-column: 3 / 5;
}

.producersContainer .inputsContainer .third {
  grid-column: 5 / 6;
}

.producersContainer .inputsContainer .fourth {
  grid-column: 1 / 2;
}

.producersContainer .inputsContainer .fifth {
  grid-column: 2 / 6;
}

/* new styles */

.producersContainer .inputsContainer .inputLabel {
  font-size: 12px;
  font-weight: 600;
  line-height: 24px;
  color: #495365;
  margin-left: 8px;
}

.producersContainer .listActions .sortBy {
  width: 100%;
  height: 48px;
  background: #fafafa;
  border-radius: 12px;
  border: none;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
}

.producersContainer .listActions .listIcons {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  background: #fffbfe;
  border: 1px solid #f4eff4;
  border-radius: 12px;
}

/* new styles */
.producersContainer .inputsContainer .listIcons {
  height: 56px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  background: #fffbfe;
  border: 1px solid #f4eff4;
  border-radius: 12px;
}

/* new styles */
.producersContainer .inputsContainer .customInput {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  background: #fffbfe;
  border: 1px solid #f4eff4;
  border-radius: 12px;
}

.producersContainer .listActions .listIcons:hover {
  border: 3px solid #f4eff4;
}

/* new styles */

.producersContainer .customInput:hover {
  border: 3px solid #f4eff4;
}

/* new styles */
.producersContainer .inputsContainer .listIcons:hover {
  border: 3px solid #f4eff4;
}

.avancedSearch {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.avancedSearch button {
  /* position: absolute; */
  display: inline-flex;
  /* top: 64px;
  right: 90px; */
  font-size: 12px;
  font-weight: 500;
  color: #4caf50;
  background: none;
  border: none;
  padding: 0;
}

/* new styles */

.avancedSearchContainer button {
  display: inline-flex;
  font-size: 12px;
  font-weight: 500;
  color: #4caf50;
  background: none;
  border: none;
  padding: 0;
}

.producersContainer .listActions .listIcons .searchInput {
  display: grid;
  grid-template-columns: 32px auto 12px;
  width: 100%;
  padding: 16px;
  gap: 17px;
  align-items: center;
}

/* new styles */

.producersContainer .customInput {
  width: 100%;
  padding: 16px;
  align-items: center;
}

/* .searchQueryContainer::-webkit-scrollbar {
  width: 50px;
} */

.searchQueryContainer {
  position: absolute;
  left: 0;
  top: 80px;
  width: 100%;
  min-height: 44px;
  max-height: 130px;
  background: #ffffff;
  border: 1px solid #f4eff4;
  box-shadow: 0px 8px 24px rgb(0 0 0 / 16%);
  border-radius: 8px;
  padding: 10px 16px;
  line-height: 2.5;
  overflow-y: auto;
  font-size: 12px;
  color: rgb(147, 144, 148);
  z-index: 100;
}

.searchQueryContainer::-webkit-scrollbar {
  width: 5px;
  height: 8px;
  border-radius: 20px;
}

.searchQueryContainer::-webkit-scrollbar-thumb {
  background: #4caf50;
  border-radius: 20px;
}

.searchQueryContainer::-webkit-scrollbar-track {
  background: #ffffff;
  border-radius: 20px;
}

.searchListOverlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  background: transparent;
}

.searchQueryContainer .searchListItem {
  font-size: 12px;
  color: #939094;
  cursor: pointer;
}

.searchQueryContainer .searchListItem:hover {
  color: #1c1b1f;
}

.searchQueryContainer .searchListItem span {
  display: flex;
  align-items: center;
}

.listIcons .searchInput .searchContainer {
  border-right: 1px solid #f4eff4;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.listIcons .searchInput input {
  position: relative;
  width: 100%;
  background: none;
  border: none;
  outline: none;
  font-size: 16px;
  color: #000000;
  z-index: 100;
}

/* new styles */
.customInput input {
  position: relative;
  width: 100%;
  background: none;
  border: none;
  outline: none;
  font-size: 16px;
  color: #000000;
  z-index: 100;
}

.listIcons .searchInput input::placeholder {
  color: #c9c5ca;
  font-size: 16px;
}

.listIcons .searchInput input:focus {
  outline: none;
  border: none;
}

/* new styles  */

.inputsContainer .customInput input::placeholder {
  color: #1f2938;
  font-size: 16px;
}

/* new styles  */

.inputsContainer .customInput input:focus {
  outline: none;
  border: none;
}

.listIcons img {
  width: 20px;
  height: 20px;
}

.listIcons .cancelIcon {
  background: none;
  border: none;
  padding: 0;
  position: relative;
  z-index: 100;
}

.listIcons .cancelIcon img {
  width: 12px;
  height: 12px;
}

.cancelTooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.cancelTooltip .tooltiptext {
  background: #ffffff;
  color: #939094;
  font-size: 12px;
  border: 1px solid #f4eff4;
  border-radius: 8px;
  box-shadow: 0px 8px 24px rgb(0 0 0 / 16%);
  height: 32px;
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: hidden;
  text-align: center;
  position: absolute;
  z-index: 1;
  top: 125%;
  left: 50%;
  margin-left: -40px;
  opacity: 0;
  transition: opacity 0.3s;
}

.cancelTooltip .tooltiptext::before {
  content: '';
  position: absolute;
  top: -50%;
  left: 50%;
  margin-left: -5px;
  border-width: 8px;
  border-style: solid;
  border-color: transparent transparent #ffffff transparent;
}

.cancelTooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

.producersContainer .listActions .listTags {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.producersContainer .listActions .listIcons .iconItem {
  background: #fafafa;
  border-radius: 12px;
  border: none;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* new styles */

.producersContainer .inputsContainer .listIcons .iconItem {
  background: #fffbfe;
  border-radius: 12px;
  border: none;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.producersContainer .listActions .listIcons .searchIcon {
  background: none;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* new styles */
.producersContainer .inputsContainer .searchIcon {
  background: none;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.producersContainer .listActions .listTags .tagItem {
  background: #fffbfe;
  border: 1px solid #f4eff4;
  border-radius: 4px;
  height: 100%;
  width: max-content;
  min-width: 56px;
  height: 24px;
  font-size: 12px;
  font-weight: 500;
  color: #484649;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.5rem;
  column-gap: 9px;
}

.tagItem img {
  width: 6px;
  height: 6px;
}

.producersContainer .listProducers {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  margin-top: 2rem;
}

.producersContainer .listProducers .producerItem {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 172px;
  background: #fafafa;
  border-radius: 14px;
  border: 1px solid #ebebeb;
  font-size: 14px;
  align-items: stretch;
  justify-content: flex-start;
  padding: 20px 20px 16px 16px;
  margin-bottom: 1rem;
}

.producersContainer .listProducers .producerItem .producerInfo {
  display: grid;
  grid-template-columns: 30% 25% 25% 20%;
  align-items: flex-start;
  padding-bottom: 1.5rem;
}

.producersContainer
  .listProducers
  .producerItem
  .producerInfo
  .requestProducer {
  background: #4caf50;
  width: 180px;
  height: 68px;
  color: #ffffff;
  border: 1px solid #39833c;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
}

.noResults {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
  font-weight: 500;
  color: #939094;
}

.noResults button {
  font-size: 12px;
  font-weight: 500;
  color: #4caf50;
  background: none;
  border: none;
  padding: 0;
}

.noResults p {
  margin-bottom: 0;
}

.noResults button,
p {
  align-self: flex-start;
}

.producerInfo .subtitle,
.producerInfoSubtitle {
  line-height: 1;
}

.requestProducer .requestText {
  width: 45%;
  text-align: left;
  font-size: 14px;
  font-weight: 700;
}

.producerItem .producerFooter {
  display: grid;
  grid-template-columns: 30% 25% 25% 20%;
  color: #c9c5ca;
}

.producerItem .producerFooter .downloadReportCointainer {
  grid-area: 1 / 4;
}

/* .producerItem .producerFooter .item:nth-child(2) {
  margin-left: -10rem;
} */

.producerItem .producerFooter .documentChip {
  background: #fafafa;
  border: 1px solid #c9c5ca;
  border-radius: 16px;
  height: 32px;
  width: 88px;
  font-size: 14px;
  font-weight: 700;
  color: #c9c5ca;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.5rem;
}

.chipIcon {
  margin-right: 0.5rem;
}

.producerItem .producerFooter .available,
.producerItem .producerFooter .available .chipIcon svg path {
  color: #4caf50;
  fill: #4caf50;
  background: #d2ebd3;
  border-color: #a5d7a7;
}

.statisticsContainer {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: sticky;
  top: 56px;
}

.statisticsContainer .statistics {
  background: #fafafa;
  width: 199px;
  height: 96px;
  border: 1px solid #ebebeb;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 1rem;
  margin-bottom: 1rem;
}

.statisticsContainer .statistics h3 {
  color: #858585;
  font-size: 24px;
  font-weight: 700;
  display: inline-block;
}

.statisticsContainer .statistics span {
  color: #858585;
  font-size: 20px;
  font-weight: 700;
}

.statisticsContainer .statistics p {
  color: #858585;
  font-size: 12px;
  font-weight: 500;
}

.statisticsContainer .statistics:first-child h3,
.statisticsContainer .statistics:first-child span {
  color: #4caf50;
}

a {
  color: #4caf50;
  text-decoration: none;
}

/* Media Queries */

@media (min-width: 640px) {
}

@media (min-width: 768px) {
}

@media (min-width: 1024px) {
}

@media (min-width: 1280px) {
  .main {
    width: 1000px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Views/Home.css"],"names":[],"mappings":"AAAA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,6CAA6C;EAC7C,gBAAgB;EAChB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,aAAa;EACb,2CAA2C;EAC3C,6BAA6B;EAC7B,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,8BAA8B;EAC9B,gDAAgD;EAChD,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,gDAAgD;EAChD,sBAAsB;EACtB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,gDAAgD;EAChD,uBAAuB;EACvB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,gDAAgD;EAChD,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,eAAe;;AAEf;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;;AAEf;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB;gBACc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA,eAAe;;AAEf;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,eAAe;;AAEf;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;;GAEG;;AAEH;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA,gBAAgB;;AAEhB;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,gBAAgB;;AAEhB;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,eAAe;;AAEf;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,2BAA2B;EAC3B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;;;;EAKE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;GAEG;;AAEH;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,kBAAkB;;AAElB;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[":root {\n  --ew: 0px;\n}\n.main {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.titleSection {\n  display: flex;\n  margin-top: 1rem;\n  align-items: center;\n  position: relative;\n}\n\n.titleSection img {\n  width: 32px;\n  height: 32px;\n}\n\n.title {\n  color: #000000;\n  font-size: 32px;\n  font-weight: 700;\n  margin-right: 19px;\n}\n\n.secondTitle {\n  color: #aeaaae !important;\n  font-size: 32px !important;\n  font-weight: 700 !important;\n  position: absolute;\n  left: 119px !important;\n  z-index: 100;\n}\n\n.subtitle {\n  color: #1c1b1f;\n  font-size: 22px;\n  font-weight: 700;\n}\n\n.producerInfoSubtitle {\n  color: #939094;\n  font-size: 13px;\n  font-weight: 400;\n}\n\n.producerInfoBusinessName {\n  color: #939094;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.divider::after {\n  content: '';\n  display: block;\n  width: 100%;\n  height: 1px;\n  background-color: #ebebeb;\n}\n\n.countProducers {\n  display: flex;\n  flex-direction: column;\n  margin-top: 3rem;\n  padding-top: 1.25rem;\n  min-height: 54.39px;\n  background-color: #ffffff;\n}\n\n.producersContainer {\n  margin-bottom: 100px;\n}\n\n.producersContainer .listActions {\n  background: white;\n  position: sticky;\n  top: 50px;\n  display: grid;\n  grid-template-columns: calc(100% - 72px) 56px;\n  column-gap: 1rem;\n  row-gap: 0.5rem;\n}\n\n/* new styles */\n.producersContainer .inputsContainer {\n  background: white;\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr 56px;\n  grid-template-rows: auto auto;\n  gap: 1rem;\n  padding-bottom: 10px;\n}\n\n.subtitleStatic {\n  padding-bottom: 0;\n  padding-top: 0;\n  position: static;\n}\n\n.subtitleFixed {\n  position: fixed !important;\n  top: 0 !important;\n  background: #ffffff !important;\n  transition: all 0.3s ease-in-out 0.2s !important;\n  width: 100% !important;\n  padding-top: 1.25rem !important;\n}\n\n.subtitleFixedHide {\n  position: fixed !important;\n  transition: all 0.3s ease-in-out 0.2s !important;\n  top: -100px !important;\n  margin-bottom: 0 !important;\n  padding-bottom: 0.5rem !important;\n}\n\n.inputsContainerFixed {\n  position: fixed !important;\n  transition: all 0.3s ease-in-out 0.2s !important;\n  top: 46.39px !important;\n  width: var(--ew) !important;\n  background: #ffffff !important;\n}\n\n.inputsContainerFixedHide {\n  position: fixed !important;\n  transition: all 0.3s ease-in-out 0.2s !important;\n  top: -170px !important;\n  width: var(--ew) !important;\n  background: #ffffff !important;\n}\n\n.min-h-162 {\n  min-height: 162px;\n}\n\n.producersContainer .inputsContainer .first {\n  grid-column: 1 / 3;\n}\n\n.producersContainer .inputsContainer .second {\n  grid-column: 3 / 5;\n}\n\n.producersContainer .inputsContainer .third {\n  grid-column: 5 / 6;\n}\n\n.producersContainer .inputsContainer .fourth {\n  grid-column: 1 / 2;\n}\n\n.producersContainer .inputsContainer .fifth {\n  grid-column: 2 / 6;\n}\n\n/* new styles */\n\n.producersContainer .inputsContainer .inputLabel {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 24px;\n  color: #495365;\n  margin-left: 8px;\n}\n\n.producersContainer .listActions .sortBy {\n  width: 100%;\n  height: 48px;\n  background: #fafafa;\n  border-radius: 12px;\n  border: none;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 1rem;\n}\n\n.producersContainer .listActions .listIcons {\n  height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  background: #fffbfe;\n  border: 1px solid #f4eff4;\n  border-radius: 12px;\n}\n\n/* new styles */\n.producersContainer .inputsContainer .listIcons {\n  height: 56px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  background: #fffbfe;\n  border: 1px solid #f4eff4;\n  border-radius: 12px;\n}\n\n/* new styles */\n.producersContainer .inputsContainer .customInput {\n  height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  background: #fffbfe;\n  border: 1px solid #f4eff4;\n  border-radius: 12px;\n}\n\n.producersContainer .listActions .listIcons:hover {\n  border: 3px solid #f4eff4;\n}\n\n/* new styles */\n\n.producersContainer .customInput:hover {\n  border: 3px solid #f4eff4;\n}\n\n/* new styles */\n.producersContainer .inputsContainer .listIcons:hover {\n  border: 3px solid #f4eff4;\n}\n\n.avancedSearch {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.avancedSearch button {\n  /* position: absolute; */\n  display: inline-flex;\n  /* top: 64px;\n  right: 90px; */\n  font-size: 12px;\n  font-weight: 500;\n  color: #4caf50;\n  background: none;\n  border: none;\n  padding: 0;\n}\n\n/* new styles */\n\n.avancedSearchContainer button {\n  display: inline-flex;\n  font-size: 12px;\n  font-weight: 500;\n  color: #4caf50;\n  background: none;\n  border: none;\n  padding: 0;\n}\n\n.producersContainer .listActions .listIcons .searchInput {\n  display: grid;\n  grid-template-columns: 32px auto 12px;\n  width: 100%;\n  padding: 16px;\n  gap: 17px;\n  align-items: center;\n}\n\n/* new styles */\n\n.producersContainer .customInput {\n  width: 100%;\n  padding: 16px;\n  align-items: center;\n}\n\n/* .searchQueryContainer::-webkit-scrollbar {\n  width: 50px;\n} */\n\n.searchQueryContainer {\n  position: absolute;\n  left: 0;\n  top: 80px;\n  width: 100%;\n  min-height: 44px;\n  max-height: 130px;\n  background: #ffffff;\n  border: 1px solid #f4eff4;\n  box-shadow: 0px 8px 24px rgb(0 0 0 / 16%);\n  border-radius: 8px;\n  padding: 10px 16px;\n  line-height: 2.5;\n  overflow-y: auto;\n  font-size: 12px;\n  color: rgb(147, 144, 148);\n  z-index: 100;\n}\n\n.searchQueryContainer::-webkit-scrollbar {\n  width: 5px;\n  height: 8px;\n  border-radius: 20px;\n}\n\n.searchQueryContainer::-webkit-scrollbar-thumb {\n  background: #4caf50;\n  border-radius: 20px;\n}\n\n.searchQueryContainer::-webkit-scrollbar-track {\n  background: #ffffff;\n  border-radius: 20px;\n}\n\n.searchListOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 99;\n  background: transparent;\n}\n\n.searchQueryContainer .searchListItem {\n  font-size: 12px;\n  color: #939094;\n  cursor: pointer;\n}\n\n.searchQueryContainer .searchListItem:hover {\n  color: #1c1b1f;\n}\n\n.searchQueryContainer .searchListItem span {\n  display: flex;\n  align-items: center;\n}\n\n.listIcons .searchInput .searchContainer {\n  border-right: 1px solid #f4eff4;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.listIcons .searchInput input {\n  position: relative;\n  width: 100%;\n  background: none;\n  border: none;\n  outline: none;\n  font-size: 16px;\n  color: #000000;\n  z-index: 100;\n}\n\n/* new styles */\n.customInput input {\n  position: relative;\n  width: 100%;\n  background: none;\n  border: none;\n  outline: none;\n  font-size: 16px;\n  color: #000000;\n  z-index: 100;\n}\n\n.listIcons .searchInput input::placeholder {\n  color: #c9c5ca;\n  font-size: 16px;\n}\n\n.listIcons .searchInput input:focus {\n  outline: none;\n  border: none;\n}\n\n/* new styles  */\n\n.inputsContainer .customInput input::placeholder {\n  color: #1f2938;\n  font-size: 16px;\n}\n\n/* new styles  */\n\n.inputsContainer .customInput input:focus {\n  outline: none;\n  border: none;\n}\n\n.listIcons img {\n  width: 20px;\n  height: 20px;\n}\n\n.listIcons .cancelIcon {\n  background: none;\n  border: none;\n  padding: 0;\n  position: relative;\n  z-index: 100;\n}\n\n.listIcons .cancelIcon img {\n  width: 12px;\n  height: 12px;\n}\n\n.cancelTooltip {\n  position: relative;\n  display: inline-block;\n  border-bottom: 1px dotted black;\n}\n\n.cancelTooltip .tooltiptext {\n  background: #ffffff;\n  color: #939094;\n  font-size: 12px;\n  border: 1px solid #f4eff4;\n  border-radius: 8px;\n  box-shadow: 0px 8px 24px rgb(0 0 0 / 16%);\n  height: 32px;\n  width: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  visibility: hidden;\n  text-align: center;\n  position: absolute;\n  z-index: 1;\n  top: 125%;\n  left: 50%;\n  margin-left: -40px;\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n\n.cancelTooltip .tooltiptext::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 8px;\n  border-style: solid;\n  border-color: transparent transparent #ffffff transparent;\n}\n\n.cancelTooltip:hover .tooltiptext {\n  visibility: visible;\n  opacity: 1;\n}\n\n.producersContainer .listActions .listTags {\n  height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.producersContainer .listActions .listIcons .iconItem {\n  background: #fafafa;\n  border-radius: 12px;\n  border: none;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* new styles */\n\n.producersContainer .inputsContainer .listIcons .iconItem {\n  background: #fffbfe;\n  border-radius: 12px;\n  border: none;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.producersContainer .listActions .listIcons .searchIcon {\n  background: none;\n  border: none;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* new styles */\n.producersContainer .inputsContainer .searchIcon {\n  background: none;\n  border: none;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.producersContainer .listActions .listTags .tagItem {\n  background: #fffbfe;\n  border: 1px solid #f4eff4;\n  border-radius: 4px;\n  height: 100%;\n  width: max-content;\n  min-width: 56px;\n  height: 24px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #484649;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 0.5rem;\n  column-gap: 9px;\n}\n\n.tagItem img {\n  width: 6px;\n  height: 6px;\n}\n\n.producersContainer .listProducers {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: 100vh;\n  margin-top: 2rem;\n}\n\n.producersContainer .listProducers .producerItem {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  min-height: 172px;\n  background: #fafafa;\n  border-radius: 14px;\n  border: 1px solid #ebebeb;\n  font-size: 14px;\n  align-items: stretch;\n  justify-content: flex-start;\n  padding: 20px 20px 16px 16px;\n  margin-bottom: 1rem;\n}\n\n.producersContainer .listProducers .producerItem .producerInfo {\n  display: grid;\n  grid-template-columns: 30% 25% 25% 20%;\n  align-items: flex-start;\n  padding-bottom: 1.5rem;\n}\n\n.producersContainer\n  .listProducers\n  .producerItem\n  .producerInfo\n  .requestProducer {\n  background: #4caf50;\n  width: 180px;\n  height: 68px;\n  color: #ffffff;\n  border: 1px solid #39833c;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem;\n}\n\n.noResults {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  font-size: 12px;\n  font-weight: 500;\n  color: #939094;\n}\n\n.noResults button {\n  font-size: 12px;\n  font-weight: 500;\n  color: #4caf50;\n  background: none;\n  border: none;\n  padding: 0;\n}\n\n.noResults p {\n  margin-bottom: 0;\n}\n\n.noResults button,\np {\n  align-self: flex-start;\n}\n\n.producerInfo .subtitle,\n.producerInfoSubtitle {\n  line-height: 1;\n}\n\n.requestProducer .requestText {\n  width: 45%;\n  text-align: left;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.producerItem .producerFooter {\n  display: grid;\n  grid-template-columns: 30% 25% 25% 20%;\n  color: #c9c5ca;\n}\n\n.producerItem .producerFooter .downloadReportCointainer {\n  grid-area: 1 / 4;\n}\n\n/* .producerItem .producerFooter .item:nth-child(2) {\n  margin-left: -10rem;\n} */\n\n.producerItem .producerFooter .documentChip {\n  background: #fafafa;\n  border: 1px solid #c9c5ca;\n  border-radius: 16px;\n  height: 32px;\n  width: 88px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #c9c5ca;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 0.5rem;\n}\n\n.chipIcon {\n  margin-right: 0.5rem;\n}\n\n.producerItem .producerFooter .available,\n.producerItem .producerFooter .available .chipIcon svg path {\n  color: #4caf50;\n  fill: #4caf50;\n  background: #d2ebd3;\n  border-color: #a5d7a7;\n}\n\n.statisticsContainer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  position: sticky;\n  top: 56px;\n}\n\n.statisticsContainer .statistics {\n  background: #fafafa;\n  width: 199px;\n  height: 96px;\n  border: 1px solid #ebebeb;\n  border-radius: 14px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 0 1rem;\n  margin-bottom: 1rem;\n}\n\n.statisticsContainer .statistics h3 {\n  color: #858585;\n  font-size: 24px;\n  font-weight: 700;\n  display: inline-block;\n}\n\n.statisticsContainer .statistics span {\n  color: #858585;\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.statisticsContainer .statistics p {\n  color: #858585;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.statisticsContainer .statistics:first-child h3,\n.statisticsContainer .statistics:first-child span {\n  color: #4caf50;\n}\n\na {\n  color: #4caf50;\n  text-decoration: none;\n}\n\n/* Media Queries */\n\n@media (min-width: 640px) {\n}\n\n@media (min-width: 768px) {\n}\n\n@media (min-width: 1024px) {\n}\n\n@media (min-width: 1280px) {\n  .main {\n    width: 1000px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
